export default __webpack_public_path__ + "static/media/bacterium.6e4c1792.svg";